import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent, PopoverComponent } from '@ui/aos-lib';

@Component({
  selector: 'aos-name-with-description',
  template: `
    @if (dataCell) {
      <div class="f-space">
        <span
          buttonContent
          class="ui-table__cell_view"
          >{{ dataCell.displayName }}</span
        >
        @if (dataCell.description) {
          <ui-popover>
            <span popoverContent>{{ dataCell.description }}</span>
            <ui-icon
              iconContent
              [name]="'view'"
            ></ui-icon>
          </ui-popover>
        }
      </div>
    }
  `,
  imports: [IconComponent, PopoverComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NameWithDescriptionComponent {
  @Input() dataCell!: { displayName: string; description: string };
}
